import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  input: {
    margin: 0,
  },
  inputLabelRoot: {
    fontSize: '16px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0.5),
  },
  InputLabelPropsFocused: {
    color: '#7C839D !important',
  },
  InputPropsFocused: {
    backgroundColor: '#fff !important',
    borderColor: theme.palette.primary.main,
  },
  InputPropsInput: {
    padding: `${theme.spacing(4)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} !important`,
  },
  inputRoot: {
    borderRadius: '10px',
    fontSize: '16px',
    backgroundColor: '#FFFFFF',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    padding: '0px !important',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    '&.MuiFilledInput-root': {
      padding: '0px !important',
      backgroundColor: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#FFFFFF',
      },
      '&:focus': {
        backgroundColor: '#FFFFFF',
      },
    },
    '& .MuiAutocomplete-input': {
      padding: `${theme.spacing(4)}px ${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(2)}px !important`,
    },
  },
  inputRootBase: {
  },
}));
